<div class="form-group">
  <label for="prod-m">{{ 'form.customer'| translate }}</label>
  <angular2-multiselect [data]="customerList"
      [(ngModel)]="customerSelected"
      [settings]="multiselectSettings_base"
      (onSelect)="onCustomerSelect()">
  </angular2-multiselect>
</div>